// EN
export const propAuthLocksHc = {
  autoridades: {
    breadcrumbCurrent: "Competent authorities",
    selectorLabel: "Select the police authority for your area",

    // Shared status fragments
    msgConnected: "Connected.",
    msgValidated: "Validated.",
    msgValidationError: "Validation error.",

    // SES Hospedajes
    sesSubtitle: "State Secretariat for Security – Ministry of the Interior",
    sesConnectedText: "Check-ins will be sent automatically to SES Hospedajes.",
    sesVerifyCreds: "Check the credentials you entered.",
    sesNotConnected: "You haven't connected a SES Hospedajes account yet.",
    updateConnectedAccount: "Update connected account",

    // Ertzaintza A19
    ertzSubtitle: "Basque Country Regional Police – Traveler registry",
    ertzConnectedText: "Check-ins will be sent automatically to the Ertzaintza.",
    ertzVerifyCif: "Check the CIF and the establishment code.",
    ertzCredsSaved: 'Credentials saved. Press "Verify connection" to check access.',
    ertzCifLabel: "Establishment CIF",
    ertzCifPlaceholder: "e.g. B12345678",
    ertzCifHint: "Max. 10 characters. Lessor's CIF registered with the Ertzaintza.",
    ertzCodeLabel: "Establishment code",
    ertzCodePlaceholder: "e.g. 01000001",
    ertzCodeHint: "Assigned by the Ertzaintza when registering the establishment.",
    envLabel: "Environment",
    envPre: "Pre-production (testing)",
    envPro: "Production",
    envHint: 'Use "Pre-production" to validate before activating in production.',
    verifying: "Verifying...",
    verifyConnection: "Verify connection",
    saving: "Saving...",
    updateCredentials: "Update credentials",
    saveAndConnect: "Save and connect",

    // Mossos d'Esquadra
    mossosSubtitle: "Generalitat de Catalunya – Registre de viatgers d'establiments d'hostalatge",

    // SIRE
    sireSubtitle: "Foreigner Registry Information System – Migración Colombia",
    sireConnectedText: "Check-ins will be sent automatically.",
    sireRevisaCreds: "Check the credentials.",
    docTypeLabel: "Document type",
    selectTypePlaceholder: "Select type",
    docNumberLabel: "Document number",
    docNumberPlaceholder: "e.g. 123456789",
    passwordLabel: "Password",
    sirePasswordPlaceholder: "SIRE password",
    showHideTitle: "Show/hide",
    saveChanges: "Save changes",

    // TRA
    traSubtitle: "Ministry of Commerce, Industry and Tourism – Authorization token",
    traReportsText: "Automatic reports enabled.",
    traRevisaToken: "Check the token/RNT.",
    traTokenLabel: "Authorization token",
    traTokenPlaceholder: "Paste the token issued by the TRA here",
    traCurrentToken: "Current token: {token}",
    traNoTokenHint: "If you don't have a PMS token yet, you can generate it at",
    traRntLabel: "Establishment RNT",
    traRntPlaceholder: "Numbers only (e.g. 123456)",
    traRntHint: "It must be the establishment's active RNT (5 to 15 digits).",

    // Document types (Colombia)
    docTypeCitizenId: "Citizenship ID card",
    docTypeForeignerId: "Foreigner ID card",

    // Alloggiati Web (residual placeholder)
    alloggiatiIdPlaceholder: "e.g. 1234",

    // Toasts / script messages
    needSaveListing: "You need to save the listing first.",
    authChangedErtz: "Authority changed to Ertzaintza (Basque Country).",
    authChangedMossos: "Authority changed to Mossos d'Esquadra (Catalonia).",
    authChangedSes: "Authority changed to SES Hospedajes.",
    authChangeError: "The authority could not be changed.",
    ertzSaved: "Ertzaintza credentials saved.",
    saveGenericError: "Error while saving.",
    ertzSaveError: "Error saving Ertzaintza credentials.",
    ertzTestOk: "Connection with the Ertzaintza verified successfully.",
    testFailedCheck: "Verification failed. Check the details.",
    ertzTestError: "Error verifying the connection with the Ertzaintza.",
    mossosNeedCreds: "Enter the username and password for the Mossos website.",
    mossosFound: "{count} establishment found. Choose yours. | {count} establishments found. Choose yours.",
    mossosNoEstablishments: "No establishments were found in this account.",
    mossosConnError: "Could not connect with Mossos. Check the username and password.",
    mossosNeedFields: "Complete the police identifier and the establishment code.",
    mossosSaved: "Mossos credentials saved.",
    mossosSaveError: "Error saving Mossos credentials.",
    mossosTestOk: "Connection with Mossos verified successfully.",
    mossosTestError: "Error verifying the connection with Mossos.",
    mossosFileOk: "File generated. Upload it on the Mossos website (Fitxers massius).",
    mossosNoTravelers: "There are no travelers pending submission.",
    mossosConfigFirst: "Configure the establishment first.",
    mossosFileError: "The file could not be generated.",
    sireCompleteData: "Complete the required data for SIRE.",
    sireSaved: "SIRE saved successfully.",
    sireSaveFailed: "SIRE could not be saved.",
    sireSaveError: "Error saving SIRE.",
    sireDeactivated: "SIRE deactivated.",
    sireActivated: "SIRE activated.",
    sireStateFailed: "The SIRE status could not be changed.",
    sireStateError: "Error changing SIRE status.",
    traNeedToken: "Enter the token and a valid RNT (numbers only).",
    traSaved: "TRA saved successfully.",
    traSaveFailed: "TRA could not be saved.",
    traSaveError: "Error saving TRA.",
    traDeactivated: "TRA deactivated.",
    traActivated: "TRA activated.",
    traStateFailed: "The TRA status could not be changed.",
    traStateError: "Error changing TRA status.",
    stateChangeFailed: "The status could not be changed.",
    alloggiatiStateError: "Error changing the Alloggiati Web status.",
    ross1000StateError: "Error changing the ROSS 1000 status.",
  },

  smartLocks: {
    loadingConfig: "Loading configuration…",
    accessKeyTypeLabel: "Access key type",
    selectLockPlaceholder: "Select lock",
    optionStatic: "Static Key",
    optionTtlock: "TTLock - Dynamic Lock",
    optionTedee: "Tedee - Dynamic Lock",
    optionShelly: "Shelly - Smart Relay",
    optionYacan: "YACAN - Smart Lock",
    optionAkiles: "Akiles - Smart Lock",
    optionOther: "Another brand not listed here…",
    pillTedee: "Dynamic access (Tedee)",
    pillTtlock: "Dynamic access (TTLock)",
    pillShelly: "Remote opening (Shelly)",
    pillYacan: "Managed access (YACAN)",
    pillAkiles: "Akiles connected",
    pillStatic: "Static access",
    pillOther: "Write to us and we'll help you integrate it",
    disconnecting: "Disconnecting…",
    disconnect: "Disconnect",
    emptyTitle: "Connect your smart lock",
    emptyText: "Choose your brand from the dropdown above to connect it and automatically generate a new key for each booking.",
    emptyBrandOther: "Other brands",
    unitFallback: "Unit {id}",
    staticModeInfo: "Static mode selected. Enter a key and press Save to apply it.",
    saveTypeError: "The access type could not be saved",
    disconnectSuccess: "Lock disconnected",
    disconnectError: "The lock could not be disconnected.",
  },

  rates: {
    pageTitle: "Rates",
    loading: "Loading rates…",
    roomsCount: "{count} room | {count} rooms",
    singleUnit: "Single unit",
    newBtn: "New",
    colName: "Name",
    colAdjustment: "Adjustment",
    colFinal: "Final price",
    labelMain: "Main",
    labelDerived: "Derived",
    base: "Base",
    editTitle: "Edit",
    copyTitle: "Copy to another unit",
    deleteTitle: "Delete",
    noDerived: "There are no derived rates for this rate plan.",
    emptyTitle: "No main rates",
    emptyText: "Create a main rate for this unit and then you'll be able to create derived ones.",
    emptyCreate: "Create first main rate",
    globalEmptyTitle: "No units loaded",
    globalEmptyText: "First create rooms/units to be able to manage rates.",
    editRate: "Edit rate",
    newRate: "New rate",
    fieldName: "Name",
    namePlaceholder: "e.g. Flexible rate",
    validityPeriod: "Validity period",
    validityPermanent: "Permanent",
    validityCustom: "Custom",
    validityHintCustom: "Optional: applies only within the range",
    validityHintPermanent: "Rate always valid",
    startLabel: "Start",
    endLabel: "End",
    pricePerNight: "Price per night",
    taxIncluded: "Taxes included",
    occupancy: "Occupancy",
    guestsNumber: "Number of guests",
    minStay: "Minimum stay",
    maxStay: "Maximum stay",
    description: "Description",
    optional: "Optional",
    rateplanBase: "Base Rate Plan",
    selectRateplanBase: "Select a base rate plan",
    rateplanBaseHint: "Select the rate plan on which this derived rate will be calculated.",
    derivedNamePlaceholder: "e.g. Booking.com, Airbnb…",
    derivedNameHint: "This name helps you identify the rate when mapping OTAs.",
    adjustmentType: "Adjustment type",
    percentage: "Percentage",
    fixedAmount: "Fixed amount",
    adjustmentValue: "Adjustment value",
    adjustmentValueHint: "(negative for a discount)",
    preview: "Preview",
    basePrice: "Base price",
    increment: "Increase",
    discount: "Discount",
    cancel: "Cancel",
    saving: "Saving...",
    update: "Update",
    create: "Create",
    deleteModalTitle: "Delete rate",
    deleteWarnStrong: "This action cannot be undone.",
    deleteWarnLead: "You are about to delete:",
    deleteCascadeLabel: "Also delete its derived rates ({count})",
    deleteCascadeHint: "If any derived rate is linked to an OTA, deletion will be blocked.",
    deleteConfirmLabel: "Type the exact name to confirm:",
    deleteConfirmPlaceholder: "Type the name exactly",
    deleteConfirmHint: "This prevents accidental deletions.",
    deleting: "Deleting...",
    deleteConfirmBtn: "Delete permanently",
    copyModalTitle: "Copy rate to another unit",
    copyOrigin: "Origin:",
    copyRate: "Rate:",
    copyTargetUnit: "Target unit",
    selectUnit: "Select a unit",
    copySameUnitHint: "You can't copy to the same unit.",
    copyTargetBaseRate: "Target base rate",
    selectMainRate: "Select a main rate",
    copyDerivedHint: "This derived rate will be linked to that main rate in the target unit.",
    copyNoMainRates: "The target unit has no main rates. Create or copy a main one first.",
    copyNewNameLabel: "Name at destination",
    copyRenameHint: "You can rename it to avoid duplicates.",
    copyCascadeLabel: "Also copy derived rates ({count})",
    copyCascadeHint: "New derived rates will be created pointing to the copied main rate plan.",
    copying: "Copying...",
    copyBtn: "Copy",

    // Toasts / script messages
    loadError: "Error loading rates",
    rangeErrorSelect: "You must select a valid date range",
    rangeErrorStartEnd: "The start date cannot be later than the end date",
    rangeErrorMinStay: "The minimum stay is {minStay} nights, but the selected range has {nights} nights",
    invalidUnit: "Invalid unit",
    completeRequired: "Complete the required fields",
    updated: "Updated",
    created: "Created",
    saveError: "Error saving",
    deleted: "Deleted",
    deleteLinkedOta: "Cannot delete: it is linked to an OTA.",
    deleteGenericError: "Error deleting",
    deleteDerivedError: "The derived rate could not be deleted",
    copied: "Copied",
    copyGenericError: "Error copying",
    invalidTargetUnit: "Invalid target unit",
    selectTargetBaseError: "Select the target base rate to link the derived rate.",
    invalidTargetBaseError: "The selected target base rate is not valid for the target unit.",
    defaultRateName: "Rate",
    defaultDerivedName: "Derived",
    copySuffix: "(Copy)",
  },
};
